
import {
    Divider
} from '@mui/material';
const CrmDivider = (props) => {
    const { children } = props
    return (
        <Divider sx={{ my: 2, color: 'text.secondary' }} textAlign="left">{children}</Divider>
    )
}

export default CrmDivider